import { ReactNode } from 'react';
import {
  ViewOptionsSectionRowContainer,
  ViewOptionsSectionRowContent,
  ViewOptionsSectionRowLabel,
  ViewOptionsSectionRightControls,
} from './atoms';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { Tag } from '@ardoq/status-ui';
import { IconButton } from '@ardoq/button';
import { colors } from '@ardoq/design-tokens';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

export type ViewOptionsSectionRowProperties = {
  rowLabel: string;
  tagContent: ReactNode;
  onClick: VoidFunction;
  iconName: IconName;
  badge?: ReactNode;
};
const ViewOptionsSectionRow = ({
  rowLabel,
  iconName,
  tagContent,
  onClick,
  badge,
}: ViewOptionsSectionRowProperties) => {
  // i18nLocale$.state OK here: simple UI label in a pure presentational component
  // that has no connected stream — rendered on every parent re-render
  const i18nLocale = i18nLocale$.state;
  return (
    <ViewOptionsSectionRowContainer
      onClick={onClick}
      role="option"
      aria-label={rowLabel}
    >
      <ViewOptionsSectionRowContent>
        <Icon
          color={colors.icon}
          iconName={iconName}
          iconSize={IconSize.LARGE}
        />
        <ViewOptionsSectionRowLabel>{rowLabel}</ViewOptionsSectionRowLabel>
        <ViewOptionsSectionRightControls>
          {badge}
          <Tag>
            {tagContent || t(i18nLocale, 'appLayout:noneLabel', 'None')}
          </Tag>
          <IconButton
            iconName={IconName.CHEVRON_RIGHT}
            label={t(i18nLocale, 'appLayout:moreLabel', 'More')}
          />
        </ViewOptionsSectionRightControls>
      </ViewOptionsSectionRowContent>
    </ViewOptionsSectionRowContainer>
  );
};

export { ViewOptionsSectionRow };
